
<!-- popup -->
<article class="popup popup-bookmark"
         *ngIf="lm.showBookmark">
  <app-bookmark-popup (closePopup)="lm.showBookmark = false"></app-bookmark-popup>
</article>

<article class="popup popup-pitch"
         *ngIf="lm.showPitch">
  <app-word-pitch-popup [word]="lm.wordPitch"
                        (closePopup)="lm.ClosePitchPopup()"></app-word-pitch-popup>
</article>

<article class="popup popup-pitch"
         *ngIf="lm.showExample">
  <app-word-example-popup [word]="lm.wordPitch"
                          [exampleSJ]="lm.exampleSJ"
                          (closePopup)="lm.CloseExamplePopup()"></app-word-example-popup>
</article>

<app-linked-example-popup *ngIf="lm.showLinkedExample && lm.linkedExample"
                          [example]="lm.linkedExample"
                          (closePopup)="lm.CloseLinkedExamplePopup()"></app-linked-example-popup>

<article class="popup popup-msg"
         *ngIf="lm.showMsgPopup">
  <app-msg-popup [config]="lm.mpConfig"
                 (clickBtn)="lm.onClickMsgBtn($event)"></app-msg-popup>
</article>

<article class="popup popup-noti"
         *ngIf="lm.showNotiPopup" [@notiPopupInOut]>
  <app-noti-popup [pushInfo]="lm.pushInfo"></app-noti-popup>
</article>


<app-youtube-player *ngIf="lm.youtubePopup$ && lm.youtubeId"
                    [youtubeId]="lm.youtubeId"></app-youtube-player>


<!-- naver-popup -->
<!-- <app-naver-login-popup *ngIf="lm.naverLoginPopup$"></app-naver-login-popup> -->
<app-naver-login-popup *ngIf="lm.showNaverLogin"></app-naver-login-popup>


<div class="cordova-youtube-bg" *ngIf="lm.cordovaYoutubeBg"></div>
